import { render } from "./marca.vue?vue&type=template&id=3fe09d1e&scoped=true"
import script from "./marca.vue?vue&type=script&lang=js"
export * from "./marca.vue?vue&type=script&lang=js"

import "./marca.vue?vue&type=style&index=0&id=3fe09d1e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fe09d1e"]])

export default __exports__